"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _check = _interopRequireDefault(require("../../icons/check"));
var _warningSolid = _interopRequireDefault(require("../../icons/warning-solid"));
require("./field-status.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var renderIcon = function renderIcon(error) {
  if (error === false || error === true) {
    return /*#__PURE__*/_react["default"].createElement(_icon["default"], {
      className: "fieldStatus__icon",
      path: error ? _warningSolid["default"] : _check["default"],
      size: "20px"
    });
  }
};

/**
 * Displays validation messages for form fields. Used by default to show errors in components
 * that use the FieldBase (Field, Select).
 */
var FieldStatus = function FieldStatus(props) {
  var className = props.className,
    error = props.error;
  var classList = (0, _classnames["default"])('fieldStatus text-xxs', _defineProperty({
    'fieldStatus--indeterminate': !(error === false || error === true),
    'fieldStatus--error': error,
    'fieldStatus--valid': !error
  }, className, Boolean(className)));
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: classList
  }, renderIcon(error), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fieldStatus__text"
  }, props.children));
};
FieldStatus.displayName = 'FieldStatus';
FieldStatus.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /**
   * Current error status. Pass `true` to mark as an error, `false` to mark that the field is valid,
   * or leave undefined for an indeterminate default state.
   */
  error: _propTypes["default"].bool
} : {};
var _default = exports["default"] = FieldStatus;